import PropTypes from 'prop-types';

import WorkshopsWithRegistrationBlock from '../../home/blocks/WorkshopsWithRegistrationBlock';
import { getString } from '../../utils';
import BlockHeader from '../BlockHeader';
import WorkshopList from './list/WorkshopList';

const gridTemplates = {
  'grid': WorkshopList,
  'registration': WorkshopsWithRegistrationBlock,
  'with-registration': WorkshopsWithRegistrationBlock,
};

const WorkshopsBlock = ({ workshopList, header, headerLevel, headerKey, itemProps, template }) => {
  const GridComponent = gridTemplates[itemProps?.gridTemplate] || gridTemplates.grid;
  // header={null} permet de masquer complètement le titre
  const title = header === null ? null : header || getString(headerKey);
  return (
    <>
      {title && <BlockHeader title={title} headerLevel={headerLevel} />}
      <GridComponent
        centered
        workshopList={workshopList}
        itemProps={itemProps}
        template={template || itemProps}
        collection="workshops"
      />
    </>
  );
};

WorkshopsBlock.defaultProps = {
  header: undefined,
  headerLevel: undefined,
  headerKey: 'blocks.sessions',
  itemProps: undefined,
  template: undefined,
};

WorkshopsBlock.propTypes = {
  header: PropTypes.string,
  headerLevel: PropTypes.string,
  headerKey: PropTypes.string,
  itemProps: PropTypes.object,
  template: PropTypes.object,
  workshopList: PropTypes.array.isRequired,
};

export default WorkshopsBlock;
